export const FORM_CONSTANTS = {
  SHARES_STEP: "0.00000001",
  SHARES_PLACEHOLDER: "0.00000000",
  PRICE_STEP: "0.01",
  PRICE_PLACEHOLDER: "0.00",
  FEE_PLACEHOLDER: "0.00"
} as const

export const STOCK_TYPES = {
  US: 'US',
  TH: 'TH', 
  FUND: 'FUND',
  GOLD: 'GOLD'
} as const

export const CURRENCIES = {
  THB: 'THB',
  USD: 'USD'
} as const